var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content && !_vm.disabled)?_c('banner',{attrs:{"color-scheme":"alert","banner-message":_vm.content,"background":_vm.description.color}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }